import React from "react";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from "../../../../components/CustomSwitch";
import { ConstantService } from "../../../../services/ConstantService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomTextInput from "../../../../components/CustomTextInput";

interface Props {
    companyTypeInformationRef: any
    isCustomer: boolean
    setIsCustomer: React.Dispatch<React.SetStateAction<boolean>>
    customerIntegrationCode: string | undefined
    setCustomerIntegrationCode: React.Dispatch<React.SetStateAction<string | undefined>>
    isSupplier: boolean,
    setIsSupplier: React.Dispatch<React.SetStateAction<boolean>>
    supplierIntegrationCode: string | undefined
    setSupplierIntegrationCode: React.Dispatch<React.SetStateAction<string | undefined>>
    isAgency: boolean,
    setIsAgency: React.Dispatch<React.SetStateAction<boolean>>
    agencyIntegrationCode: string | undefined
    setAgencyIntegrationCode: React.Dispatch<React.SetStateAction<string | undefined>>
    isSenderFirm: boolean
    setIsSenderFirm: React.Dispatch<React.SetStateAction<boolean>>
    isReceiverFirm: boolean
    setIsReceiverFirm: React.Dispatch<React.SetStateAction<boolean>>
    isAirlineFirm: boolean
    setIsAirlineFirm: React.Dispatch<React.SetStateAction<boolean>>
    isDutyFirm: boolean
    setIsDutyFirm: React.Dispatch<React.SetStateAction<boolean>>
    isSeawayFirm: boolean
    setIsSeawayFirm: React.Dispatch<React.SetStateAction<boolean>>
    isCompany: boolean
    setIsCompany: React.Dispatch<React.SetStateAction<boolean>>
    canBeEdited: boolean,
    selectedInitialCompanyType: CustomSingleSelectModel | undefined
    setSelectedInitialCompanyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    isRepresentative: boolean
    setIsRepresentative: React.Dispatch<React.SetStateAction<boolean>>
    isInsuranceFirm: boolean
    setIsInsuranceFirm: React.Dispatch<React.SetStateAction<boolean>>
    senderFirmIntegrationCode: string | undefined
    setSenderFirmIntegrationCode: React.Dispatch<React.SetStateAction<string | undefined>>
    receiverFirmIntegrationCode: string | undefined
    setReceiverFirmIntegrationCode: React.Dispatch<React.SetStateAction<string | undefined>>
}

const CompanyTypeInformation = ({
    companyTypeInformationRef,
    isCustomer,
    setIsCustomer,
    customerIntegrationCode,
    setCustomerIntegrationCode,
    isSupplier,
    setIsSupplier,
    setSupplierIntegrationCode,
    supplierIntegrationCode,
    isAgency,
    setIsAgency,
    agencyIntegrationCode,
    setAgencyIntegrationCode,
    isSenderFirm,
    setIsSenderFirm,
    isReceiverFirm,
    setIsReceiverFirm,
    isAirlineFirm,
    setIsAirlineFirm,
    isDutyFirm,
    setIsDutyFirm,
    isSeawayFirm,
    setIsSeawayFirm,
    isCompany,
    setIsCompany,
    canBeEdited,
    selectedInitialCompanyType,
    setSelectedInitialCompanyType,
    isRepresentative,
    setIsRepresentative,
    isInsuranceFirm,
    setIsInsuranceFirm,
    senderFirmIntegrationCode,
    setSenderFirmIntegrationCode,
    receiverFirmIntegrationCode,
    setReceiverFirmIntegrationCode
}: Props) => {
    return (
        <div className='containerPart' ref={companyTypeInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Firma Türü Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Müşteri</label>

                                <Box flexDirection="row">
                                    <Box width="80px">
                                        <CustomSwitch
                                            disabled={!canBeEdited}
                                            isActive={isCustomer}
                                            setIsActive={() => {
                                                setIsCustomer(!isCustomer);
                                                setCustomerIntegrationCode('');
                                            }}
                                        />
                                    </Box>
                                    <Box ml="15px" flexGrow={1}>
                                        <CustomTextInput
                                            isDisabled={!canBeEdited || !isCustomer}
                                            value={customerIntegrationCode}
                                            setValue={setCustomerIntegrationCode}
                                        />
                                    </Box>
                                </Box>
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Tedarikçi</label>

                                <Box flexDirection="row">
                                    <Box width="80px">
                                        <CustomSwitch
                                            disabled={!canBeEdited}
                                            isActive={isSupplier}
                                            setIsActive={() => {
                                                setIsSupplier(!isSupplier);
                                                setSupplierIntegrationCode('');
                                            }}
                                        />
                                    </Box>
                                    <Box ml="15px" flexGrow={1}>
                                        <CustomTextInput
                                            isDisabled={!canBeEdited || !isSupplier}
                                            value={supplierIntegrationCode}
                                            setValue={setSupplierIntegrationCode}
                                        />
                                    </Box>
                                </Box>
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Acente</label>

                                <Box flexDirection="row">
                                    <Box width="80px">
                                        <CustomSwitch
                                            disabled={!canBeEdited}
                                            isActive={isAgency}
                                            setIsActive={() => {
                                                setIsAgency(!isAgency);
                                                setAgencyIntegrationCode('');
                                            }}
                                        />
                                    </Box>
                                    <Box ml="15px" flexGrow={1}>
                                        <CustomTextInput
                                            isDisabled={!canBeEdited || !isAgency}
                                            value={agencyIntegrationCode}
                                            setValue={setAgencyIntegrationCode}
                                        />
                                    </Box>
                                </Box>
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label required">Firma Durumu</label>
                                <CustomSingleSelect
                                    selectedValue={selectedInitialCompanyType}
                                    onChange={setSelectedInitialCompanyType}
                                    onMenuOpen={() => ConstantService.getConstantList('MEETING_COMPANY_TYPE')}
                                    labelName='value'
                                    valueName='constantId'
                                    additionalValue1Name="additionalValue1"
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Gönderici Firma</label>

                                <Box flexDirection="row">
                                    <Box width="80px">
                                        <CustomSwitch
                                            disabled={!canBeEdited}
                                            isActive={isSenderFirm}
                                            setIsActive={() => {
                                                setIsSenderFirm(!isSenderFirm);
                                                setSenderFirmIntegrationCode('');
                                            }}
                                        />
                                    </Box>
                                    <Box ml="15px" flexGrow={1}>
                                        <CustomTextInput
                                            isDisabled={!canBeEdited || !isSenderFirm}
                                            value={senderFirmIntegrationCode}
                                            setValue={setSenderFirmIntegrationCode}
                                        />
                                    </Box>
                                </Box>
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Alıcı Firma</label>

                                <Box flexDirection="row">
                                    <Box width="80px">
                                        <CustomSwitch
                                            disabled={!canBeEdited}
                                            isActive={isReceiverFirm}
                                            setIsActive={() => {
                                                setIsReceiverFirm(!isReceiverFirm);
                                                setReceiverFirmIntegrationCode('');
                                            }}
                                        />
                                    </Box>
                                    <Box ml="15px" flexGrow={1}>
                                        <CustomTextInput
                                            isDisabled={!canBeEdited || !isReceiverFirm}
                                            value={receiverFirmIntegrationCode}
                                            setValue={setReceiverFirmIntegrationCode}
                                        />
                                    </Box>
                                </Box>
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Gümrük Firması</label>

                                <CustomSwitch disabled={!canBeEdited} isActive={isDutyFirm} setIsActive={setIsDutyFirm} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Şirket</label>

                                <CustomSwitch disabled={!canBeEdited} isActive={isCompany} setIsActive={setIsCompany} />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Havayolu</label>

                                <CustomSwitch disabled={!canBeEdited} isActive={isAirlineFirm} setIsActive={setIsAirlineFirm} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Denizyolu</label>

                                <CustomSwitch disabled={!canBeEdited} isActive={isSeawayFirm} setIsActive={setIsSeawayFirm} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Mümessil</label>

                                <CustomSwitch disabled={!canBeEdited} isActive={isRepresentative} setIsActive={setIsRepresentative} />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Sigorta Firması</label>

                                <CustomSwitch disabled={!canBeEdited} isActive={isInsuranceFirm} setIsActive={setIsInsuranceFirm} />
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default CompanyTypeInformation;